<div #documents id="documents" class="flex">
    <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
      <div class="mb-8 flex flex-col justify-center">
        <div class="pt-12 pb-2">
          <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
        </div>
        <div class="flex justify-between items-end">
          <div>
            <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
          </div>
          <div class="justify-items-end">
            <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
                class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
                class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
          </div>
        </div>
        <div class="pb-4">
          <div>{{modelProperty?.title}}</div>
        </div>
        <div>
            <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
        </div>
      </div>
    </div>
    <div name="main" class="py-8 flex flex-col sm:w-auto md:w-1/2  bg-white">
      <div class="flex flex-col sm:w-auto md:hidden p-8">
        <div class="mb-2">
          <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
        </div>
        <div class="flex justify-between items-end ">
          <div>
            <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
          </div>
          <div class="justify-items-end">
            <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
                class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
                class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
          </div>
        </div>
        <div>
          <div>{{modelProperty?.title}}</div>
        </div>
      </div>
      <div class="md:px-16">
        <div class="px-8">
          <div class="pb-4">
            <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
          </div>
          <div class="flex flex-row box-border-inactive pb-4">
            <div class="col-span-1">
              <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
            </div>
            <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
              <div class="col-span-6">
                <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
              </div>
              <div class="col-span-3 sm:text-right">
                <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                  routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
              </div>
            </div>
          </div>
          <div class="flex flex-row box-border-inactive pb-4">
            <div class="col-span-1">
              <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
            </div>
            <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
              <div class="col-span-6">
                <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
                <p>Driver’s license, social security, marital status, children and pets</p>
              </div>
              <div class="col-span-3 sm:text-right">
                <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                  routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
              </div>
            </div>
          </div>
          <div class="flex flex-row box-border-inactive pb-4">
            <div class="col-span-1">
              <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
            </div>
            <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
              <div class="col-span-6">
                <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
                <p>Two years of residency history information</p>
              </div>
              <div class="col-span-3 sm:text-right">
                <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                  routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
              </div>
            </div>
          </div>
          <div class="flex flex-row box-border-inactive pb-4">
            <div class="col-span-1">
              <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
            </div>
            <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
              <div class="col-span-6">
                <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
                <p>Two years of employment information</p>
              </div>
              <div class="col-span-3 sm:text-right">
                <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                  routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
              </div>
            </div>
          </div>
          <div>
          </div>
          <div class="flex box-border-active pb-4">
            <div class="col-span-1">
              <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
            </div>
            <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
              <div class="w-full">
                <h2 class="text-lg font-bold my-6">Identity & Income</h2>
              </div>
            </div>
          </div>
          <div *ngIf="showIframe && !isLoading && !failedResult" id="verifast-verify-container">
            <app-verifast-iframe
            [setfailedResult]="setfailedResult"
            [setIsLoadingFunc]="setIsLoading"
            [setVerificationResult]="setVerificationResult"
            [setShowIframe]="setShowIframe"
            [iFrameURL]="iFrameURL"
            ></app-verifast-iframe>
          </div>
          <div *ngIf="!isLoading">
            <div class="w-full" style="margin-left: 10px;" *ngIf="!showIframe && !ocrConfirmed && !showConfirmOcr">
              ID Verification Required
            </div>
            <div class="w-full" style="margin-left: 10px;" *ngIf="isIdentityVerified && !showIframe && !showConfirmOcr && ocrConfirmed">
              Identity Verified<mat-icon style="color: green;">check</mat-icon>
            </div>
            <div class="md:flex md:items-center w-full mt-2">
              <div class="mr-2" *ngIf="!showIframe && !showConfirmOcr && !ocrConfirmed">
                    <button mat-flat-button color="primary" (click)="getVerifastUrl(false)" class="h-10 px-6 my-2 ml-2">Validate ID</button>
                </div>
            </div>
            <div class="w-full" style="margin-left: 10px;" *ngIf="isIncomeVerified && !showIframe && !showConfirmOcr">
              Income Verified<mat-icon style="color: green;">check</mat-icon>
            </div>
            <div class="md:flex md:items-center w-full mt-2">
              <div class="mr-2" *ngIf="!isIncomeVerified && !showIframe && !showConfirmOcr">
                  <button mat-flat-button color="primary" (click)="getVerifastUrl(true)" class="h-10 px-6 my-2 ml-2">Validate Income</button>
              </div>
            </div>
            <div class="md:flex md:items-center w-full mt-2">
              <div class="mr-2" *ngIf="isIncomeVerified && !showIframe">
                  <button mat-flat-button color="primary" (click)="getVerifastUrl(true)" class="h-10 px-6 my-2 ml-2">Validate Additional Income</button>
              </div>
            </div>
            <div class="md:flex md:items-center w-full mt-2" style="margin-left: 10px;" *ngIf="!showIframe && !showConfirmOcr">
              Need to provide a future employment contract or offer letter as proof of income? After selecting Validate Income above and completing the process,
              you will have the opportunity to upload additional supporting documents in the next step of the application.
            </div>
            <div>
              <!-- OCR data section -->
              <form *ngIf="showConfirmOcr" #confirmForm="ngForm" class="sm:w-5/6">
                <div id="confirm-info-container" class="grid grid-cols-1">
                  <div class="justify-self-start">
                    <div class="text-xl font-denim-semibold">CONFIRM YOUR INFORMATION</div>
                    <div class="text-gray-tricon mt-4">All fields required.</div>
                  </div>
                  <div *ngIf="!isLoading" class="grid grid-cols-1">
                    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                        <mat-label>First Name</mat-label>
                        <input matInput type="text" name="FirstName" id="FirstName" required [readonly]="!firstNameEmpty" [(ngModel)]="model.FirstName"
                          #FirstName="ngModel">
                      </mat-form-field>

                      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                        <mat-label>Middle Name</mat-label>
                        <input matInput type="text" name="MiddleName" id="MiddleName" [readonly]="!middleNameEmpty" [(ngModel)]="model.MiddleName"
                          #MiddleName="ngModel">
                      </mat-form-field>
                    </div>

                    <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" name="LastName" id="LastName" required [readonly]="!lastNameEmpty" [(ngModel)]="model.LastName"
                        #LastName="ngModel">
                    </mat-form-field>

                    <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                      <mat-label>Street</mat-label>
                      <input matInput type="text" name="Address" id="Address" [readonly]="!addressEmpty" [(ngModel)]="model.Address" #Address="ngModel">
                    </mat-form-field>

                    <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                      <mat-label>City</mat-label>
                      <input matInput type="text" name="City" id="City" [readonly]="!cityEmpty" [(ngModel)]="model.City" #City="ngModel">
                    </mat-form-field>

                    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                      <mat-form-field class="my-2" hideRequiredMarker="true">
                        <mat-label>State</mat-label>
                        <input matInput type="text" name="State" id="State" [readonly]="!stateEmpty" [(ngModel)]="model.State" #State="ngModel">
                      </mat-form-field>

                      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                        <mat-label>Zip Code</mat-label>
                        <input matInput type="text" name="Zip" id="Zip" [readonly]="!zipEmpty" [(ngModel)]="model.Zip" #Zip="ngModel">
                      </mat-form-field>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                      <mat-form-field class="my-2" hideRequiredMarker="true">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dbPicker" name="DateOfBirth" id="LicenseExDateOfBirthiration" required [readonly]="!dateOfBirthEmpty"
                          [(ngModel)]="model.DateOfBirth" #DateOfBirth="ngModel">
                        <mat-datepicker-toggle matSuffix [disabled]="!dateOfBirthEmpty" [for]="dbPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dbPicker></mat-datepicker>
                      </mat-form-field>
                      <div></div>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
                        <mat-label>Identification Number</mat-label>
                        <input matInput type="text" name="LicenseNumber" id="LicenseNumber" required [readonly]="!licenseNumberEmpty" [(ngModel)]="model.LicenseNumber"
                          #LicenseNumber="ngModel">
                      </mat-form-field>

                      <mat-form-field class="my-2" hideRequiredMarker="true">
                        <mat-label>Expiration Date</mat-label>
                        <input matInput [matDatepicker]="lePicker" name="LicenseExpiration" id="LicenseExpiration" required [readonly]="!licenseExpirationEmpty"
                          [(ngModel)]="model.LicenseExpiration" #LicenseExpiration="ngModel">
                        <mat-datepicker-toggle matSuffix [disabled]="!licenseExpirationEmpty" [for]="lePicker"></mat-datepicker-toggle>
                        <mat-datepicker #lePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="text-right flex-1">
                    <button mat-flat-button color="accent" style="padding-left: 5px; padding-right: 5px; margin-bottom: 10px;" (click)="deny()">DENY INFORMATION</button>
                    <button mat-flat-button color="accent" style="margin-left: 20px; padding-left: 5px; padding-right: 5px;" (click)="accept()" [disabled]="!confirmForm.form.valid">CONFIRM INFORMATION</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="text-right flex-1">
              <button mat-flat-button color="primary" (click)="continue()" class="h-10 px-6 my-2 ml-2" style="pointer-events: all" [disabled]="!continueEnabled"
                matTooltip="Please complete income validation process before continuing." [matTooltipDisabled]="continueEnabled">
                CONTINUE
              </button>
            </div>
          </div>
          <div *ngIf="isLoading" class="flex justify-center"><mat-progress-spinner
                mode="indeterminate"></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
